const manageClickOutside = ({ target }, openClass, overlayClass, callback) => {
  if (target.closest(openClass) || target.closest(overlayClass)) return;

  callback(null, true);
};

export default manageClickOutside;
